import React, { Component } from 'react';

import {default as BlottingPaper} from 'components/blottingPaper/Predictions';
import SceneData from 'data/scene.json';

import './Predictions.scss';

import { withTranslation } from 'react-i18next'

class Predictions extends Component {
    constructor(props) {
        super(props);

        this.state = {
          predictions: []
        }
    }

    buildComponent = (data) => {

      const components = data.components.map((component, index) => (
        <BlottingPaper tabIndex={0} key={index} id={component.props.id} />
      ));
      return (components)
    }

    componentDidMount(){
      this.setState({
          predictions: this.buildComponent(SceneData["Blotting Paper"])
      })
    }

    render() {
        return (
          <div className="Predictions">
              <div>
                  <p className="description" tabIndex={0}>{this.props.t("During this simulation, you will be dispensing different volumes of liquid red dye with a micropipette onto a blotting paper. How do you think the different volumes will influence the size of red circles you expect to see on the blotting paper? Make your predictions here by adjusting the controls to make each circle larger or smaller.")}</p>
              </div>
              <div>
                {this.state.predictions}
              </div>
          </div>
        );
    }
}

export default withTranslation()(Predictions);
